// extracted by mini-css-extract-plugin
export default {"root":"NumbersBox_root__2Altu","movein":"NumbersBox_movein__SwrQG"};